import Card from "components/DesignSystem/Card/Card";
import { CheckListAccordion } from "./CheckListAccordion";
import { FinancialClosing } from "store/apis/financialClosing";
import { OtherFinancialsReviewPending } from "./OtherFinancialsReviewPending";

export const OtherAttachemetsView = ({
  otherFinancials,
}: {
  otherFinancials: FinancialClosing["other_financials"];
}) => {
  return (
    <Card.Root className="t-rounded-lg sm:!t-px-3" variant="primary">
      <Card.Body>
        <CheckListAccordion.Root
          type="multiple"
          defaultValue={["OtherAttachments"]}
        >
          <CheckListAccordion.Item value="OtherAttachments">
            <CheckListAccordion.Trigger>
              <span className="t-text-subtitle">Other Attachments</span>
            </CheckListAccordion.Trigger>
            <CheckListAccordion.Content>
              <div
                className={
                  "t-flex t-flex-col t-pt-4 t-gap-4 t-w-full t-border-r-0 t-border-0 t-border-solid t-border-i-neutral-10 t-border-l-surface-transparen t-border-t"
                }
              >
                <OtherFinancialsReviewPending
                  otherFinancials={otherFinancials}
                />
              </div>
            </CheckListAccordion.Content>
          </CheckListAccordion.Item>
        </CheckListAccordion.Root>
      </Card.Body>
    </Card.Root>
  );
};
